export enum InductionStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REVOKED = "REVOKED",
}
